import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changeCustomerValue = createAction('CHANGE_CUSTOMER_VALUE');

export const findCustomerList = (pagingData, serachData) => (
  (dispatch) => {
    let searchDataUrl = '';
    if (serachData != null) {
      searchDataUrl = '&searchKeys=';
      for (let i = 0; i < serachData.searchKeys.length; i++) {
        searchDataUrl += serachData.searchKeys[i] + ',';
      }
      searchDataUrl += '&searchWord=' + serachData.searchWord;
    }

    let url = '/firefighter/customers?activePage=' + pagingData.activePage + '&itemPerPage=' + pagingData.itemPerPage + searchDataUrl;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_CUSTOMER_LIST',
        payload: json
      });
    });
  }
);

export const addCustomer = (customer, pagingData) => (
  (dispatch) => {
		let url = '/firefighter/customers';
    authFetch('POST', url, JSON.stringify(customer), (json) => {
      dispatch({
				type: 'ADD_CUSTOMER',
				payload: json
      });
			dispatch(findCustomerList(pagingData));
    });
  }
);

export const editCustomer = (customer, pagingData) => (
  (dispatch) => {
		let url = '/firefighter/customers/' + customer.get('customerId');
    authFetch('PUT', url, JSON.stringify(customer), (json) => {
      dispatch({
				type: 'EDIT_CUSTOMER',
				payload: json
      });
			dispatch(findCustomerList(pagingData));
    });
  }
);

export const deleteCustomer = (deleteKey, pagingData) => (
  (dispatch) => {
		let url = '/firefighter/customers';
    authFetch('DELETE', url, JSON.stringify(deleteKey), (json) => {
      dispatch({
				type: 'DELETE_CUSTOMER',
				payload: json
      });
			dispatch(findCustomerList(pagingData));
    });
  }
);

export const findCustomer = (pk) => (
  (dispatch) => {
		let url = '/firefighter/customers/' + pk.customer_id;
    authFetch('GET', url, null, (json) => {
      dispatch({
				type: 'FIND_CUSTOMER',
				payload: json
      });
    });
  }
);

export const changeCustomerActivePage = createAction('CHANGE_CUSTOMER_ACTIVE_PAGE');
export const openCustomerModal = createAction('OPEN_CUSTOMER_MODAL');
export const closeCustomerModal = createAction('CLOSE_CUSTOMER_MODAL');

export const findAllCustomerIds = () => (
  (dispatch) => {
    let url = '/firefighter/customers/customerIds';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ALL_CUSTOMERIDS',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/customerActions.js